import axios from 'axios';
import * as constants from "../Constatnts";

// export function saveDraftTransaction(transaction,transactionType, key){
//     return (dispatch, getState) => {
//         let draft = {}
//         draft.ActionOn = firebase.firestore.FieldValue.serverTimestamp()
//         draft.ActionBy = getState().user.user.Name
//         draft.ActionByUID = getState().user.user.UID
//         draft.ActionByEmailID = getState().user.user.EmailID
//         draft.RegistrationID= getState().user.user.RegistrationID
//         draft.StoreID= getState().user.store.key
//         draft.TransactionType = transactionType //inventory, sales
//         draft.Transaction = transaction
//         if(key.trim()!== "")
//         {
//             return database.collection("Drafts").doc(key).update({
//                 ...draft
//               })
//         }
//         else
//         {
//             return database.collection("Drafts").add({
//                 ...draft
//               })
//               .then(function(docRef) {
//                   return docRef.id
//               })
//               .catch(function(error) {
//                   console.error("Error adding drafts: ", error);
//               })
//         }
        
//     }
// }




export function saveDraftTransaction(transaction, transactionType, key = "") {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key && key.trim() !== "") {
        response = await axios.put(
          `${constants.API_URL}/drafttransaction/${key}`,
          transaction,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        const requestBody = {
          data: transaction,
          storeID: transaction.Store.key,
          transactionType: transactionType,
        };

        response = await axios.post(
          `${constants.API_URL}/drafttransaction`,
          requestBody,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      
        return response.data.key;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

// export function saveDraftTransaction(transaction,transactionType, key){
//     return (dispatch, getState) => {

        
//         let draft = {}
//         draft.ActionOn = firebase.firestore.FieldValue.serverTimestamp()
//         draft.ActionBy = getState().user.user.Name
//         draft.ActionByUID = getState().user.user.UID
//         draft.ActionByEmailID = getState().user.user.EmailID
//         draft.RegistrationID= getState().user.user.RegistrationID
//         draft.StoreID= getState().user.store.key
//         draft.TransactionType = transactionType //inventory, sales
//         draft.Transaction = transaction
//         if(key.trim()!== "")
//         {
//             return database.collection("Drafts").doc(key).update({
//                 ...draft
//               })
//         }
//         else
//         {
//              let newDraftDoc = database.collection("Drafts").doc();
//              newDraftDoc.set(draft)
//              return newDraftDoc.id

//             // return database.collection("Drafts").add({
//             //     ...draft
//             //   })
//             //   .then(function(docRef) {
//             //       return docRef.id
//             //   })
//             //   .catch(function(error) {
//             //       console.error("Error adding drafts: ", error);
//             //   })
//         }
        
//     }
// }


export function deleteDraftTransaction(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.delete(
        `${constants.API_URL}/drafttransaction/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true;
      }
      else{
        return false;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getDraftTransactions(transactionType) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/drafttransactions?storeID=${getState().user.store.key}&&transactionType=${transactionType}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
      return response.data.searchResult;
      }
      else{
        alert("failed to fetch draft ");
        return [];
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
